// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup__header{
    margin:0 0 1.5rem;
    text-align:center;
  }
.signup__header h1{
      font-size:1.75rem;
      line-height:2.625rem;
      margin-bottom:0.5rem;
    }
.signup__login-container{
    margin:1.5rem 0;
    text-align:center;
  }
.signup__instructions{
    margin:0 0 1rem;
    text-align:center;
  }
.signup__terms{
    margin-top:1rem;
    color:#707070;
    text-align:center;
  }
.signup .warn div{
    margin-top:0.25rem;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
